import React, { useMemo, useId } from "react";
import { FormGroup, Input, Label } from "reactstrap";
import type { FormikFieldType } from "interfaces/shared.types";

type CheckboxInputProps = {
  field: FormikFieldType;
  label: React.ReactNode | string;
  classNames: string;
  htmlFor: string;
  onChange: () => void;
};

export const CheckboxInput = ({
  field,
  label,
  classNames,
  htmlFor,
  onChange,
  ...restProps
}: CheckboxInputProps) => {
  const id = useId();

  const inputId = useMemo(
    () => htmlFor || `checkbox-${field?.name || "input"}-${id}`,
    [htmlFor, field?.name, id],
  );

  return (
    <FormGroup check className={classNames}>
      <Input
        {...field}
        {...restProps}
        id={inputId}
        onChange={onChange || field.onChange}
      />
      <Label
        check
        htmlFor={inputId}
        style={{
          minWidth: "9rem",
        }}
      >
        {label}
      </Label>
    </FormGroup>
  );
};
